import { AuthUtility } from '@dbg-ui/auth';
import HttpErrorResponseModel from '../models/HttpErrorResponseModel';
import * as HttpUtility from './HttpUtility';

export async function getToModel(Model, endpoint, params = {}, secured = true) {
  const response = await _sendRequestWithBearer(HttpUtility.get, endpoint, params, secured);
  return _restModelCreator(Model, response);
}

export async function postToModel(Model, endpoint, data = {}, secured = true) {
  const response = await _sendRequestWithBearer(HttpUtility.post, endpoint, data, secured);

  return _restModelCreator(Model, response);
}

export async function putToModel(Model, endpoint, data = {}, headers, secured = true) {
  const response = await _sendRequestWithBearer(HttpUtility.put, endpoint, data, secured);

  return _restModelCreator(Model, response);
}

export async function deleteToModel(Model, endpoint, params = {}, secured = true) {
  const response = await _sendRequestWithBearer(HttpUtility.del, endpoint,params, secured);

  return _restModelCreator(Model, response);
}

function _restModelCreator(Model, response) {
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }

  if (!Array.isArray(response.data)) {
    return new Model(response.data);
  } else {
    return response.data.map((json) => new Model(json));
  }
}


async function _sendRequestWithBearer(requestFunction, endpoint, params = {}, secured) {
  const headers = createBearerHeaders(secured);
  let response = await requestFunction(endpoint, headers, params);

  if (!headers.Authorization) {
    window.location.href = '/';
  }

  if (response instanceof HttpErrorResponseModel && isTokenExpired(headers)) {
    const refreshed = await AuthUtility.getTokenFromRefreshToken();
    if (refreshed) {
      response = await requestFunction(endpoint, createBearerHeaders(secured), params);
    } else {
      console.log('Session expired!');
      window.location.href = '/';
    }
  }
  return response;
}

function createBearerHeaders(secured) {
  const idToken = localStorage.getItem('id_token');
  return secured && idToken ? {Authorization: `Bearer ${idToken}`} : {};
}

function isTokenExpired(headers) {
  try {
    const token = headers.Authorization.split(' ')[1];
    const payload = JSON.parse(decodeBase64Url(token.split('.')[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return false;
  }
}

function decodeBase64Url(str) {
  return atob(str.replace(/-/g, '+').replace(/_/g, '/').padEnd(str.length + (4 - str.length % 4) % 4, '='));
}
